/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ValidationType } from "../../records/types/ValidationType";
export const UniqueConstraintConfig = core.serialization.object({
    caseSensitive: core.serialization.boolean().optional(),
    ignoreEmpty: core.serialization.boolean().optional(),
    message: core.serialization.string().optional(),
    level: ValidationType.optional(),
});
